module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }